import { ChangeDetectionStrategy, Component } from '@angular/core';
import { first, orderBy } from 'lodash-es';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { FilterSelect } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-select.model';
import { FilterSelectBase } from '@nimbus-library/features/shared/components/nimbus-grid-filter/nimbus-filter-select-base';

@Component({
  standalone: false,
  selector: 'nimbus-nimbus-filter-select',
  templateUrl: './nimbus-filter-select.component.html',
  styleUrls: ['./nimbus-filter-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterSelectComponent extends FilterSelectBase<FilterSelect> {
  protected getSummary(): string {
    if (!this.filterValue?.length || !this.filter.options?.length) {
      return this.translateService.instant(TranslationKeys.FilterAll);
    }

    const options = this.filter.options.reduce((acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    }, {});
    const optionsSelected = orderBy(
      this.filterValue.map((x) => options[x]).filter((x) => !!x),
      (c) => c.name.toLowerCase(),
      'asc',
    );

    const value = first(optionsSelected)?.name ?? first(this.filterValue);
    return this.filterValue.length === 1 ? value : `${value} +${this.filterValue.length - 1}`;
  }

  protected onFilterValueChanged(): void {}
}
